import React from 'react';

import HasPendingRequestWarning from '../budget_approval_requests/HasPendingRequestWarning';

import EditIcon from 'Assets/icons/edit.svg';

export default function PackItemCard({ item, onEdit, type, fullSize = true, grouped = false }) {
    if (type === 'simple') {
        return <SimplePackItemCard item={item} onEdit={onEdit} fullSize={fullSize} grouped={grouped} />;
    }

    return <ContractorPackItemCard item={item} onEdit={onEdit} fullSize={fullSize} grouped={grouped} />;
}

const SimplePackItemCard = ({ item, onEdit, fullSize, grouped }) => {
    const wrapperClass = grouped ? 'tw-bg-transparent tw-text-sm' : 'tw-rounded-lg tw-border-2 tw-border-gray-200 tw-bg-white tw-text-sm';
    return (
        <div className={wrapperClass}>
            <div className="tw-p-2.5 tw-flex tw-items-center tw-gap-2">
                <div className="tw-basis-full tw-shrink tw-grow">
                    <div>{item.name}</div>
                </div>
                <div className="tw-basis-full tw-shrink tw-grow">
                    <div className="tw-text-center">{item.price}</div>
                </div>
                {!!item.can_be_edited && (
                    <div className="tw-basis-6 tw-shrink-0 tw-flex tw-flex-col tw-items-end tw-justify-end">
                        <button onClick={(e) => onEdit()}>
                            <EditIcon className="tw-w-4 tw-h-4" />
                        </button>
                    </div>
                )}
            </div>
            {!item.can_be_edited && <HasPendingRequestWarning />}
        </div>
    );
};

const ContractorPackItemCard = ({ item, onEdit, fullSize, grouped }) => {
    const wrapperClass = grouped ? 'tw-bg-transparent tw-text-sm' : 'tw-rounded-lg tw-border-2 tw-border-gray-200 tw-bg-white tw-text-sm';
    return (
        <div className={wrapperClass}>
            <div className="tw-p-2.5 tw-flex tw-gap-2">
                <div className="tw-basis-full tw-shrink tw-grow tw-flex tw-flex-col tw-justify-between">
                    <div>{item.name}</div>
                </div>
                <div className="tw-basis-full tw-shrink tw-grow tw-flex tw-flex-col tw-justify-between tw-text-center">
                    <div>{item.price || 0}</div>
                </div>
                {fullSize && (
                    <>
                        <div className="tw-basis-full tw-shrink tw-grow tw-flex tw-flex-col tw-justify-between">
                            <div className="tw-text-center">{item.start_time_before || 0}</div>
                        </div>
                        <div className="tw-basis-full tw-shrink tw-grow tw-flex tw-flex-col tw-justify-between">
                            <div className="tw-text-center">{item.finish_time_after || 0}</div>
                        </div>
                        <div className="tw-basis-full tw-shrink tw-grow tw-flex tw-flex-col tw-justify-between">
                            <div className="tw-text-center">{item.min_shift_duration || 0}</div>
                        </div>
                        <div className="tw-basis-full tw-shrink tw-grow tw-flex tw-flex-col tw-justify-between">
                            <div className="tw-text-center">{item.max_shift_duration || 0}</div>
                        </div>
                        <div className="tw-basis-full tw-shrink tw-grow tw-flex tw-flex-col tw-justify-between">
                            <div className="tw-text-center">{item.shift_overlap || 0}</div>
                        </div>
                    </>
                )}
                {!!item.can_be_edited && (
                    <div className="tw-basis-6 tw-shrink-0 tw-flex tw-flex-col tw-items-end tw-justify-end">
                        <button onClick={(e) => onEdit()}>
                            <EditIcon className="tw-w-4 tw-h-4" />
                        </button>
                    </div>
                )}
            </div>
            {!item.can_be_edited && <HasPendingRequestWarning />}
        </div>
    );
};
